import { render, staticRenderFns } from "./homeDashboardUserStatistics.vue?vue&type=template&id=279f2a79&scoped=true"
import script from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardUserStatistics.vue?vue&type=style&index=0&id=279f2a79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f2a79",
  null
  
)

export default component.exports